export default __webpack_public_path__ + "static/media/faqArrowDown.7918e594.svg";